import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ToastrService } from "ngx-toastr";
import { SharedService } from "../../shared/shared.service";
import { BehaviorSubject, Subject } from "rxjs";
import { ProductService } from "./product.service";
import { environment } from "../../../environments/environment";

@Component({
    selector: "app-product",
    templateUrl: "./product.component.html",
    styleUrls: ["./product.component.scss"],
    standalone: false
})
export class ProductComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  productForm: FormGroup;
  submitted = false;
  public isEdit: boolean = false;
  products: any[] = [];
  variants: any[] = [];
  dealers: any[] = [];
  categories: any[] = [];
  colors: any[] = [];
  isLoading: Subject<boolean> = new Subject<boolean>();
  public ELEMENT_DATA: any = [];
  filteredProducts: any = [];
  selectedProductId: any;
  filteredVariants: any[] = [];
  productVariant: any = [];
  filteredColor: any = [];

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private sharedService: SharedService,
    private productService: ProductService
  ) {
    this.productForm = this.fb.group({
      product_model_id: ["", Validators.required],
      variant_id: ["", Validators.required],
      outlet_id: [[], Validators.required],
      product_category_id: ["", Validators.required],
      color_id: ["", Validators.required],
      status: ["", Validators.required],
    });
  }
  displayedColumns: string[] = [
    "SNo",
    "product_model",
    "product_variant",
    "product_category",
    "outlet",
    "product_color",
    "status",
    "action",
  ];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort();
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  public searchInput = new FormControl("");
  public isCreate: boolean = false;
  // public submitted: boolean = false;
  masters: any = [];
  dropdownSettingsProCategory = {};
  statusList:any=[{id:1, name:"Acitve"},{id:0, name:"In-Active"}]
  ngOnInit() {
    this.getProducts();
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    setTimeout(() => {
      const masters = JSON.parse(sessionStorage.getItem("masters") || "{}");
      if (masters) {
        this.masters = masters;
        this.products = this.masters.productModel || [];
        this.productVariant = this.masters.productVariant || [];
        this.dealers = this.masters.outlets || [];
        this.categories = this.masters.productCategory || [];
        this.colors = this.masters.productColor || [];
      }
    }, 700);
    this.dropdownSettingsProCategory = {
      singleSelection: false,
      enableCheckAll: true,
      idField: "id",
      textField: "outlet_name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
  }
  get f() {
    return this.productForm.controls;
  }

  add() {
    this.isCreate = true;
  }

  loadMasterRecords() {
    const masters = JSON.parse(sessionStorage.getItem("masters") || "{}");
    if (masters) {
      this.masters = masters;
      this.products = this.masters.productModel || [];
      this.productVariant = this.masters.productVariant || [];
      this.dealers = this.masters.outlets || [];
      this.categories = this.masters.productCategory || [];
      this.colors = this.masters.productColor || [];


    }
  }

  selectedObject: any = {};
  editData(object: any) {

    this.isEdit = true;
    this.selectedObject = object;
    // Load master records from session storage
    this.loadMasterRecords();
    // Filter products and variants based on the selected category and model
    this.filteredProducts = this.products.filter(
      (product: any) => product.category_id === parseInt(object.product_category_id)
    );
    this.filteredVariants = this.productVariant.filter(
      (variant: any) => variant.model_id === object.product_model_id
    );
    // Set the form values after loading the master records
    this.productForm.patchValue({
      product_model_id: object?.product_model_id,
      variant_id: object.variant_id,
      outlet_id: object.outlets,
      product_category_id: object.product_category_id,
      color_id: object?.product_color.id,
      status: object.status ? 1 : 0,
    });
  }


  update() {
    this.submitted = true;

    if (this.productForm.valid) {
      const productData: any = { ...this.productForm.value };

      if (typeof productData.outlet_id === "object") {
        productData.outlet_id = productData.outlet_id.map(
          (item: any) => item.id
        );
      }

      productData.status = parseInt(productData.status);

      this.isLoading = new BehaviorSubject<boolean>(true);

      this.productService
        .updateProduct(productData, this.selectedObject.id)
        .subscribe(
          (response: any) => {
            let responseData = response.body;
            if (responseData.responseCode == 200) {
              this.isLoading = new BehaviorSubject<boolean>(false);
              this.toastr.success("Product updated successfully!");
              this.back();
            } else {
              this.isLoading = new BehaviorSubject<boolean>(false);
              this.toastr.error(response.body.responseMessage);
            }
          },
          (err: any) => {
            this.isLoading = new BehaviorSubject<boolean>(false);
          }
        );
    }
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getProducts();
  }

  createProduct() {
    this.submitted = true;
    if (this.productForm.valid) {
      const productData: any = this.productForm.value;
      productData.outlet_id = productData.outlet_id.map((item: any) => item.id);

      this.isLoading = new BehaviorSubject<boolean>(true);
      this.productService.createProduct(productData).subscribe(
        (response: any) => {
          let responseData = response.body;
          if (responseData.responseCode == 200) {
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.toastr.success("Product created successfully!");
            this.back();
          } else {
            this.isLoading = new BehaviorSubject<boolean>(false);
            this.toastr.error(response.body.responseMessage);
          }
        },
        (err: any) => {
          this.isLoading = new BehaviorSubject<boolean>(false);
        }
      );
    }
  }

  getProducts() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.productService.getProducts().subscribe(
      (response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.ELEMENT_DATA = responseData.data;
          this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
        }
      },
      (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    );
  }

  clearForm() {
    this.submitted = false;
    this.productForm.patchValue({
      product_model_id: "",
      status: "",
      variant_id: "",
      product_category_id: "",
      color_id: "",
      outlet_id: "",
    });
  }

  allowAplhabetsOnly(event: any) {
    this.sharedService.allowAlphabetsOnly(event);
  }
  onCategoryChange(event: any) {
    const categoryId = event.target.value;
    if (categoryId) {
      this.filteredProducts = this.products.filter(
        (product: any) => product.category_id === parseInt(categoryId)
      );
    } else {
      this.filteredProducts = [];
    }
  }
  onModelChange(event: any) {
    const target = event.target as HTMLSelectElement;
    const selectedOption = target.selectedOptions[0];
    this.selectedProductId = parseInt(selectedOption.id);
    this.filteredVariants = this.productVariant.filter(
      (variant: any) => variant.model_id === this.selectedProductId
    );
  }

  onColorChange(event: any) {
    this.filteredColor = this.colors.filter(
      (color: any) => color.id === this.selectedProductId
    );
  }
}
